import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  selectContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
  tableCell: {
    width: "50%",
    textAlign: "left",
  },
  tableSelect: {
    "& .MuiTableCell-root": {
      border: "none",
    },
    "& table": {
      width: "100%",
      tableLayout: "fixed",
    },
    "& td": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "50%",
    },
  },
  customList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    "& li": {
      height: "50px",
      lineHeight: "50px",
      padding: "0 10px",
    },
    "& li:first-child": {
      position: "sticky",
      top: 0,
      left: 0,
      right: 0,
      zIndex: 999,
      backgroundColor: "rgb(240, 90, 48)",
      opacity: 1,
      "& .MuiTableCell-head": {
        color: "#fff",
      },
    },
    "& li:nth-child(2)": {
      // marginTop: "10px",
    },
  },
}));

const TableSelect = ({
  rows,
  columns,
  handleChange,
  category,
  helperValidation,
  disabled,
  value,
}) => {
  const classes = useStyles();

  const [selectedRow, setSelectedRow] = React.useState('');

  useEffect(() => {
    setSelectedRow(value);
  }, [value])

  const handleSampleCode = (e) => {
    const { value } = e.target;
    setSelectedRow(value);
    handleChange(e, "sampleCode", value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel>{category} Code *</InputLabel>
      <Select
        value={selectedRow}
        label="Code"
        onChange={(e) => handleSampleCode(e)}
        renderValue={(selected) => (
          <div className={classes.selectContainer}>{selected.value}</div>
        )}
        disabled={disabled}
        error={helperValidation.error}
        className="custom-table-select"
        MenuProps={{
          classes: {
            list: classes.customList,
          },
          PaperProps: {
            style: {
              marginTop: "95px",
              maxHeight: "350px",
              maxWidth: "45%"
            },
          },
        }}
      >
        <MenuItem disabled value={null}>
          <Table>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.field} className={classes.tableCell}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          </Table>
        </MenuItem>
        {rows.map((row) => (
          <MenuItem key={row.id} value={row}>
            <Table className={classes.tableSelect}>
              <TableBody>
                <TableRow hover selected={row === selectedRow}>
                  {columns.map((column) => (
                    <TableCell key={column.field} className={classes.tableCell}>
                      {row[column.field]}
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </MenuItem>
        ))}
      </Select>
     
      <FormHelperText className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error Mui-required">
        {helperValidation.helperText}
      </FormHelperText>
    </FormControl>
  );
};

export default TableSelect;
